<div *ngIf="option">
  <!-- TEXT -->
  <div *ngIf="option.optionTypeId === 1">
    <textarea
      rows="5"
      [(ngModel)]="option.optionValues[0].description"
      [disabled]="isDisabled()"
      required
    ></textarea>
    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </div>

  <!-- TRUE / FALSE -->
  <div *ngIf="option.optionTypeId === 2">
    <mat-radio-group
      class="truefalse__list"
      (change)="radioSelectionChanged($event)"
      [required]="isRequired"
      [(ngModel)]="trueFalsePreSelectedValue"
    >
      <mat-radio-button
        class="truefalse__item"
        *ngFor="let optionValue of option.optionValues"
        [value]="optionValue.optionValueId"
        [checked]="optionValue.isSelected"
        [disabled]="isDisabled()"
      >
        {{ optionValue.description }}
      </mat-radio-button>
    </mat-radio-group>
    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </div>

  <!--DROP DOWN-->
  <div *ngIf="option.optionTypeId === 3">
    <ng-select
      [items]="sortedOptionVals"
      bindLabel="description"
      [disabled]="isDisabled()"
      class="stationselector"
      [required]="isRequired"
      bindValue="optionValueId"
      [(ngModel)]="dropDownPreSelectedValue"
      placeholder="{{ placeHolderText }}"
      (change)="dropDownSelectionChanged($event)"
      (search)="onSearch($event)"
      [multiple]="false"
    >
    </ng-select>

    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </div>

  <!-- CHECKBOX LIST -->
  <ul class="checkbox__list grid grid--row-4" *ngIf="option.optionTypeId === 4">
    <li *ngFor="let optionValue of option.optionValues">
      <mat-checkbox
        (change)="triggerQuestionAnswered()"
        class="checkbox__item"
        [required]="isRequired"
        [(ngModel)]="optionValue.isSelected"
        [disabled]="isDisabled()"
      >
        {{ optionValue.description }}

        <div
          *ngIf="containsHelpText(optionValue)"
          class="question__help"
          [matTooltip]="optionValue.helpText"
          matTooltipPosition="right"
        >
          <mat-icon>help</mat-icon>
        </div>
      </mat-checkbox>
    </li>
    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </ul>

  <!-- RADIOBUTTON LIST -->
  <div *ngIf="option.optionTypeId === 5">
    <mat-radio-group
      class="radiobutton__list grid grid--row-4"
      (change)="radioSelectionChanged($event)"
      [required]="isRequired"
      [(ngModel)]="radioButtonPreSelectedValue"
    >
      <mat-radio-button
        class="radiobutton__item"
        *ngFor="let optionValue of option.optionValues"
        [value]="optionValue.optionValueId"
        [checked]="optionValue.isSelected"
      >
        {{ optionValue.description }}

        <div
          *ngIf="containsHelpText(optionValue)"
          class="question__help"
          [matTooltip]="optionValue.helpText"
          matTooltipPosition="right"
        >
          <mat-icon>help</mat-icon>
        </div>
      </mat-radio-button>
    </mat-radio-group>
    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </div>

  <!-- TEXT Single line -->
  <div *ngIf="option.optionTypeId === 6">
    <input
      type="text"
      [disabled]="isDisabled()"
      [(ngModel)]="option.optionValues[0].description"
      required
    />
    <div class="requiredError" *ngIf="showError()">Answer is required</div>
  </div>
  <div *ngFor="let optionValue of option.optionValues">
    <div *ngIf="containsNestedQuestions(optionValue)">
      <div *ngFor="let ovqg of optionValue.optionValueQuestionGroups">
        <div *ngIf="containsNestedQuestionGroupQuestions(ovqg)">
          <div *ngFor="let qgq of ovqg.questionGroup!.questionGroupQuestions">
            <app-question-group-question [questionGroupQuestion]="qgq"></app-question-group-question>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
